import {
    type FieldPath,
    type FieldValues,
    type UseControllerProps,
} from 'react-hook-form';

import { Form as Root } from './Form';
import { FormInput } from './FormInput';
import { FormSubmitButton } from './FormSubmitButton';
import { useController, useFormContext, useFormState, useWatch } from './hooks';
import { useFormSchema } from './useFormSchema';

export function Form<TFieldValues extends FieldValues = FieldValues>() {
    return {
        Root: Root<TFieldValues>,
        Input: FormInput<TFieldValues>,
        SubmitButton: FormSubmitButton,
        useContext: useFormContext<TFieldValues>,
        useWatch: <
            TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
        >(
            props: UseControllerProps<TFieldValues, TName>
        ) => useWatch<TFieldValues, TName>(props),
        useController: <
            TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
        >(
            props: UseControllerProps<TFieldValues, TName>
        ) => useController<TFieldValues, TName>(props),
        useSchema: useFormSchema<TFieldValues>,
        useState: useFormState<TFieldValues>,
    };
}
